import { apiClient } from 'services/api-client';

export type BillingInterval = 'month' | 'year';

export interface BillingSummary {
  billing_configured: boolean;
  status: 'trial' | 'active' | 'past_due' | 'canceled';
  trial_ends_at: string | null;
  trial_days_left: number;
  has_subscription: boolean;
  billing_interval: BillingInterval | null;
  billed_stores: number | null;
  current_period_end: string | null;
  cancel_at_period_end: boolean;
  active_stores: number;
  price_per_store: Record<BillingInterval, number>;
}

export class BillingService {
  static async getSummary(orgId: string): Promise<BillingSummary> {
    return (await apiClient.get<BillingSummary>(`/orgs/${orgId}/billing/subscription`)).data;
  }

  static async startCheckout(orgId: string, interval: BillingInterval): Promise<string> {
    return (await apiClient.post<{ url: string }>(`/orgs/${orgId}/billing/checkout`, { interval })).data.url;
  }

  static async openPortal(orgId: string): Promise<string> {
    return (await apiClient.post<{ url: string }>(`/orgs/${orgId}/billing/portal`)).data.url;
  }
}
